import { render, staticRenderFns } from "./ProducerOrGroupDetail.vue?vue&type=template&id=52817826&scoped=true&"
import script from "./ProducerOrGroupDetail.vue?vue&type=script&lang=js&"
export * from "./ProducerOrGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProducerOrGroupDetail.vue?vue&type=style&index=0&id=52817826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52817826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VRow})
